import { ThemeEnum } from './enum'

/** 默认主题色 */
export const defaultTheme: ThemeEnum = ThemeEnum.Dark
